import { Component, inject, input } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { MenuItem } from '../../model/menu-item';
import { IconComponent } from '@app/shared/components';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-item',
    imports: [TranslatePipe, RouterModule, IconComponent],
    templateUrl: './item.component.html',
    styleUrl: './item.component.css',
    host: {
        class: 'admin-menu-item',
    },
})
export class ItemComponent {
    readonly item = input.required<MenuItem>();
    readonly activatedRoute = inject(ActivatedRoute).root;
}
